module.exports = __webpack_public_path__ + "img/arrows-move.62002351.svg";